import axios from 'axios';

// API 基础 URL
const API_BASE_URL = 'https://www.rocyu.com';

// 创建一个 axios 实例
const api = axios.create({
  baseURL: API_BASE_URL,
});

// 请求拦截器，自动添加 token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// API 服务
const getShopProducts = () => api.get('/api/shop/products');
const addShopProduct = (data) => api.post('/api/shop/products', data);
const createShopOrder = (product_id, quantity = 1) => api.post('/api/shop/orders', { product_id, quantity });
const getShopOrders = () => api.get('/api/shop/orders');

const deactivateShopProduct = (productId) => api.post(`/api/shop/products/${productId}/deactivate`);

// 编辑商品
const editShopProduct = (productId, data) => api.put(`/api/shop/products/${productId}`, data);
// 删除商品
const deleteShopProduct = (productId) => api.delete(`/api/shop/products/${productId}`);
const activateShopProduct = (productId, stock) => api.post(`/api/shop/products/${productId}/activate`, { stock });
const getPendingOrdersCount = () => api.get('/api/admin/orders/pending-count');
const importSolitaire = (activityId, names) => api.post(`/api/activities/${activityId}/import_solitaire`, { names });

const apiService = {
  // 系统配置相关,
  importSolitaire,
  getSystemConfig: () => api.get('/api/system/config'),
  setSystemConfig: (data) => api.post('/api/system/config', data),
  getAutoTaskStatus: () => api.get('/api/system/auto-award-status'),
  editShopProduct,
  deleteShopProduct,
  // 管理员/工会委员获取所有报名记录
  getAllUserActivities: () => api.get('/api/admin/user-activities'),
  activateShopProduct,
  // 认证相关
  login: (credentials) => api.post('/api/auth/login', credentials),
  
  // 用户相关
  getUsers: () => api.get('/api/users'),
  getUser: (id) => api.get(`/api/users/${id}`),
  getCurrentUser: () => api.get('/api/user'),
  createUser: (userData) => api.post('/api/users', userData),
  updateUser: (id, userData) => api.put(`/api/users/${id}`, userData),
  deleteUser: (id) => api.delete(`/api/users/${id}`),
  
  // 活动相关
  getActivities: () => api.get('/api/activities'),
  openActivityEnroll: (activityId) => api.post(`/api/activities/${activityId}/enroll_open`),
  closeActivityEnroll: (activityId) => api.post(`/api/activities/${activityId}/enroll_close`),
  getActiveActivities: () => api.get('/api/activities/active'),
  getActivity: (id) => api.get(`/api/activities/${id}`),
  getActivityRegistrations: (id) => api.get(`/api/activities/${id}/registrations`),
  createActivity: (activityData) => api.post('/api/activities', activityData),
  updateActivity: (id, activityData) => api.put(`/api/activities/${id}`, activityData),
  deleteActivity: (id) => api.delete(`/api/activities/${id}`),
  
  // 用户活动相关
  getUserActivities: () => api.get('/api/user-activities'),
  registerActivity: (activityId) => api.post(`/api/activities/${activityId}/register`, {}),
  cancelRegistration: (activityId) => api.delete(`/api/activities/${activityId}/register`),
  updateUserActivityStatus: (userActivityId, status) => api.put(`/api/user-activities/${userActivityId}/status`, { status }),
  
  // 积分相关
  getUserPoints: () => api.get('/api/points/user'),
  getPointsRanking: () => api.get('/api/points/ranking'),
  adjustUserPoints: (data) => api.post('/api/points/adjust', data),
  resetAllPoints: (data) => api.post('/api/points/reset', data),
  getUserPointsById: (userId) => api.get(`/api/points/user/${userId}`),
  getPointsLogs: () => api.get('/api/points/logs'),
  // 积分商城相关
  getShopProducts,
  addShopProduct,
  createShopOrder,
  getShopOrders,
  getPendingOrdersCount,
  deactivateShopProduct: (productId) => api.post(`/api/shop/products/${productId}/deactivate`),
};

const getAdminOrders = (status) => api.get('/api/admin/orders', { params: status ? { status } : {} });
const updateOrderStatus = (orderId, status) => api.put(`/api/admin/orders/${orderId}/status`, { status });


export { getShopProducts, addShopProduct, createShopOrder, getShopOrders, deactivateShopProduct, editShopProduct, deleteShopProduct, getAdminOrders, updateOrderStatus, getPendingOrdersCount };
export default apiService;
